import {IPayment3DSClientMethodGathering} from "../../../airline-webapi/responses/begin-booking-payment.response";
import {IServiceFactory} from "../../../service-factory.interface";
import {delay} from "../../../../utils/util-functions";



export class ThreeDSMethodGatheringHandler {
    constructor(methodGatheringParams: IPayment3DSClientMethodGathering,
                private readonly services: IServiceFactory) {

        this._htmlIframe = document.createElement('iframe');
        this._htmlIframe.style.display = 'none';
        this._htmlIframe.width = '0';
        this._htmlIframe.height = '0';
        this._htmlIframe.name = 'threeDSMethodIframe';

        this._htmlForm = document.createElement('form');
        this._htmlForm.style.display = 'none';
        this._htmlForm.method = 'post';
        this._htmlForm.action = methodGatheringParams.threeDSMethodUrl;
        this._htmlForm.target = this._htmlIframe.name;

        for(let formParamName of Object.keys(methodGatheringParams.formParams)) {
            const uniqueInput = document.createElement('input');
            uniqueInput.type = 'hidden';
            uniqueInput.name = formParamName;
            uniqueInput.value = methodGatheringParams.formParams[formParamName] ?? "";
            this._htmlForm.appendChild(uniqueInput);
        }

        document.body.appendChild(this._htmlIframe);
        document.body.appendChild(this._htmlForm);
    }

    private readonly _htmlIframe: HTMLIFrameElement;
    private readonly _htmlForm: HTMLFormElement;

    dispose(): void {
        this._htmlForm.remove();
        this._htmlIframe.remove();
    }

    execute(): Promise<void> {
        try {

            const promise = new Promise<void>((resolve) => {
                const resolvePromise = async () => {
                    await delay(Date.now(), 500);
                    resolve();
                }
                this._htmlIframe.onload = async () => {
                    await resolvePromise();
                }
                this._htmlIframe.onerror = async (err) => {
                    this.services.logger.error('3DS method gathering form post failed', err);
                    await resolvePromise();
                }
            })

            this._htmlForm.submit();
            return promise;
        } catch (err) {
            this.services.logger.error('Failed to submit 3DS method gathering form', err);
            return Promise.resolve();
        }

    }





}